import { HttpClient, JSON_STRING } from "../../services/http/http-client";
import { CONTACTS_URL } from "../../modules/booking/services/booking-service";

export const GroupService = {
  findUnrelatedGroups: ({
    contact_id
  }) => HttpClient.get(CONTACTS_URL, {
    action: 'group_form_n_unrelated_groups',
    contact_id
  }),
  searchUnrelatedGroups: ({
    search,
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'search_unrelated_groups',
    tableID: 'unrelated_groups_table',
    output: JSON_STRING,
    search,
    contact_id
  }),
  insertGroupRelation: ({
    contact_id,
    group_ids,
    checked_group_ids,
  }) => HttpClient.get(CONTACTS_URL, {
    action: 'relate_groups',
    external_table: 'groups',
    output: JSON_STRING,
    contact_id,
    group_ids,
    checked_group_ids
  }),
  insertNewGroup: ({
    group_name,
    contact_id
  }) => HttpClient.get(CONTACTS_URL, {
    action: 'create_group',
    external_table: 'groups',
    group_name,
    contact_id
  }),
  removeGroupRelation: ({
    contact_id,
    external_id,
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'relate',
    external_table: 'groups',
    contact_id,
    external_id,
  })
}